var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page__content",class:[(!_vm.showPanel || _vm.isLoginPage()) ? 'fullwidth' : '', _vm.showPanel && !_vm.navigationIsClosed ? 'menu-opened' : '', (_vm.$route.name === 'chats' ? 'p-0' : '')]},[_c('page-loader'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }